<script>
export default {
  props: {
    noValidPayment: {
      type: Boolean,
      required: true
    }
  }
};
</script>

<template>
  <div class="footer">
    <span>{{ noValidPayment ? "finalizar pagamento" : "ver pedido" }}</span>

    <img src="/static/basic/arrow-next.svg" />
  </div>
</template>

<style scoped>
.footer {
  margin-top: 16px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}

.footer > span {
  font-size: 14px;
  font-weight: 400;
  color: #603285;
}

.footer > img {
  width: 14px;
  height: 14px;
}
</style>



// WEBPACK FOOTER //
// src/components/Order/Components/Card/Footer.vue